import React, { FC } from 'react';

import { connect } from 'react-redux';
import st from './MobileFiltersButton.module.css';
import {
  structuredSelector,
  StructuredSelectorProps,
} from './structuredSelector';

interface MobileFIlterButtonProps extends StructuredSelectorProps {
  onClick: () => void;
}

const MobileFIlterButton: FC<MobileFIlterButtonProps> = ({ show, onClick }) =>
  show && (
    <button
      aria-label="show"
      data-testid="showMobileFiltersButton"
      type="button"
      className={st.openButton}
      onClick={onClick}
    />
  );

export default connect(structuredSelector)(MobileFIlterButton);
